import { Testimonial } from "../../components/types";

export const testimonials: Testimonial[] = [
  {
    text: "Communication with Verse is top-notch. I greatly appreciate how quick and efficient the turn around has been.",
    author: "Kylie",
    role: "Outpatient Facility Manager in Kansas",
    bgColor: "tw-bg-blue-2",
    textColor: "tw-text-white",
    imageSrc: "landing_page_assets/avatars/avatar1.png",
    avatarClassName:
      "tw-rounded-full tw-border-[2px] tw-border-white tw-border-solid",
  },
  {
    text: "The simplicity of ordering supplies for our managed patients is wonderful. We have never worked with a company that is so streamline and responsive.",
    author: "Maria",
    role: "Wound Care Program Director in Texas",
    bgColor: "tw-bg-[#005C99]",
    textColor: "tw-text-white",
    imageSrc: "landing_page_assets/avatars/avatar3.png",
    avatarClassName:
      "tw-rounded-full tw-border-[2px] tw-border-white tw-border-solid",
  },
  {
    text: "Verse has eliminated so many of our DME problems and is much easier for both staff and patients.",
    author: "Wyatt",
    role: "Intake Coordinator in Tennessee",
    bgColor: "tw-bg-[#CCEBFF]",
    textColor: "tw-text-black",
    imageSrc: "landing_page_assets/avatars/avatar2.png",
    avatarClassName:
      "tw-rounded-full tw-border-[2px] tw-border-white tw-border-solid",
  },
  {
    text: "You are the best kept secret for home health agencies! We were at a conference a few weeks ago and they asked which DME provider we use and we referred you to everyone!",
    author: "Spencer",
    role: "Registered Nurse in Arizona",
    bgColor: "tw-bg-[#003D66]",
    textColor: "tw-text-white",
    imageSrc: "landing_page_assets/avatars/avatar4.png",
    avatarClassName:
      "tw-rounded-full tw-border-[2px] tw-border-white tw-border-solid",
  },
];
